import { NvEmptyState, NvErrorState, NvSkeleton } from "@/components/navigator";
import { useRequest } from "@/hooks/use-request";
import { getTerms } from "@/services/navigator/signup-service";

// 푸터의 이용약관 · 개인정보처리방침. 회원가입 · Contact Us의 약관 전문 보기 팝업(NvTermsModal)과 같은 DB 문서
// (GET /terms → terms_versions 의 현재 버전)를 같은 방식(줄바꿈 그대로, 시행 버전 표기)으로 보여줘요.
const EMPTY_LABEL: Record<string, string> = {
  service_terms: "이용약관을 불러오지 못했습니다.",
  privacy_policy: "개인정보 처리방침을 불러오지 못했습니다.",
};

export function NavigatorTermsPage({ code = "service_terms" }: { code?: "service_terms" | "privacy_policy" }) {
  const { data, error, reload } = useRequest((signal) => getTerms([code], signal), [code]);
  const terms = data?.find((t) => t.code === code) ?? null;

  return (
    <div className="mx-auto w-full max-w-[880px] px-5 pb-24 pt-14">
      {error ? (
        <NvErrorState error={error} onRetry={reload} />
      ) : !data ? (
        <div aria-hidden className="flex flex-col gap-3">
          <NvSkeleton className="h-[34px] w-[200px]" />
          <NvSkeleton className="h-4 w-[110px]" />
          <NvSkeleton className="mt-5 h-[320px] w-full" />
        </div>
      ) : !terms ? (
        <NvEmptyState>{EMPTY_LABEL[code]}</NvEmptyState>
      ) : (
        <article>
          <h1 className="text-[28px] font-medium leading-[34px] text-nv-text-primary">{terms.title}</h1>
          <p className="mt-2 text-[12px] leading-[19px] text-nv-text-secondary">시행 버전 {terms.version}</p>
          <p className="mt-8 whitespace-pre-line text-[14px] leading-[24px] text-nv-text-secondary">{terms.body}</p>
        </article>
      )}
    </div>
  );
}
